import { inject } from "vue";
import { filter, findIndex, map } from "underscore";

export enum AlertType {
  "success" = "success",
  "warning" = "warning",
  "error" = "error",
  "info" = "info",
}

export const ALERT_DELAY_DEFAULT = 5000;

export interface AlertDetails {
  type: AlertType;
  message: string | string[];
  delay: number;
}

const formatErrorMessages = (errors: Record<string, string>) => {
  const updatedErrors: Record<string, string> = {};

  for (const [key, value] of Object.entries(errors)) {
    const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
    updatedErrors[key] = value.replace(
      new RegExp(`\\b${key}\\b`),
      capitalizedKey,
    );
  }
  return updatedErrors;
};

export default () => {
  const emitter: any = inject("emitter");
  const alert = (
    message: string | string[],
    type: AlertType = AlertType.success,
    delay: number = ALERT_DELAY_DEFAULT,
  ) => {
    emitter.emit("alert", {
      type,
      message,
      delay,
    });
  };
  const errorHandlerAlert = (
    error: any,
    delay: number = ALERT_DELAY_DEFAULT,
  ) => {
    const data = error.response?.data;
    // If Errors Object has many errors returned from the Backend
    if (data.errors && Object.keys(data.errors).length > 0) {
      const errors = formatErrorMessages(error.response.data.errors);
      showFilteredAlert(
        map(Object.values(errors), (message: string) => ({
          message,
        })),
        delay,
      );
      return;
    }
    // If Error Message or Error Is returned from the Backend as single string
    alert(data?.errorMessage ?? data?.error ?? error, AlertType.error, delay);
  };

  const showFilteredAlert = (
    validityMessages: { message: string }[],
    delay: number = ALERT_DELAY_DEFAULT,
  ) => {
    alert(
      filter(
        validityMessages,
        (validation: any, index: any, messageData: any) =>
          findIndex(
            messageData,
            (item: any) => item.message === validation.message,
          ) === index,
      ),
      AlertType.error,
      delay,
    );
  };

  return {
    alert,
    errorHandlerAlert,
    showFilteredAlert,
  };
};
